//Node Modules
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../.././../store/Actions/actions";
import cloneDeep from "lodash.clonedeep";
import {
  Alert,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import classnames from "classnames";

//Custom React Components
import Popup from "../../Modal/Popup";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import Counter from "../../Tool/Counter/Counter";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";
import SortableDragAndDrop from "../../Tool/SortableDragAndDrop/SortableDragAndDrop";

//Styles
import "./AccordionSettings.scss";
import EditIcon  from "../../../assets/images/editForm.svg";
import  DeleteIcon  from "../../../assets/images/delete.svg";
import  DuplicateIcon  from "../../../assets/images/clone.svg";

//JS
import * as UTILS from "../../../utils/Utils";

const AccordionSettings = (props) => {
  const [activeTab, setActiveTab] = useState("1");
  const [initialItems, setInitialItems] = useState(
    Object.keys(props.element.columns).map((key) =>
      Object({
        key: key,
        title: props.element.columnSettings[key].itemHeader.title,
      })
    )
  );
  useEffect(() => {
    setInitialItems(
      Object.keys(props.element.columns).map((key) =>
        Object({
          key: key,
          title: props.element.columnSettings[key].itemHeader.title,
        })
      )
    );
  }, [props]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const addLabel = (e) => {
    let labelValue = e.target.value;
    let layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.element.id,
      (item) => {
        item.label = labelValue;
      },
      (colItem) => {
        colItem.label = labelValue;
      }
    );

    props.layoutArray(props.layoutTitle, newLayout);
  };

  const selectIconType = (e) => {
    if (e.target.name == "mobileIcon") {
      let iconType = e.target.value;
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.iconType = iconType;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.iconType = iconType;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (e.target.name == "desktopIcon") {
      let iconType = e.target.value;
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.iconType = iconType;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.iconType = iconType;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const multiItemExpandToggle = (e) => {
    const checked = e.target.checked;
    let layout = cloneDeep(props.layout);
    if (e.target.value == "desktop") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.multiItemExpand = checked;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.multiItemExpand = checked;
        }
      );
    }
    if (e.target.value == "mobile") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.multiItemExpand = checked;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.multiItemExpand = checked;
        }
      );
    }

    props.layoutArray(props.layoutTitle, newLayout);
  };

  const toggleWidthUnit = (e) => {
    let widthUnit = e.target.value;

    let layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.element.id,
      (item) => {
        item.accordion.widthUnit = widthUnit;
      },
      (colItem) => {
        colItem.accordion.widthUnit = widthUnit;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const setAccordionWidth = (value, deviceType, action) => {
    value = value && value.replace(/^0+/, "");
    var widthValue = value === "" ? 0 : Number(value);

    var desktopValue =
      action == "plus"
        ? Number(props.element.accordion.desktopStyle.width) + 1
        : Number(props.element.accordion.desktopStyle.width) - 1;
    var mobileValue =
      action == "plus"
        ? Number(props.element.accordion.mobileStyle.width) + 1
        : Number(props.element.accordion.mobileStyle.width) - 1;

    mobileValue > 375
      ? (mobileValue = 375)
      : mobileValue < 0
      ? (mobileValue = 0)
      : null;

    widthValue < 0 ? (widthValue = 0) : null;
    desktopValue > 1200
      ? (desktopValue = 1200)
      : desktopValue < 0
      ? (desktopValue = 0)
      : null;

    if (deviceType === "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.width =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : widthValue;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.width =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : widthValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType === "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.width =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : widthValue;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.width =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : widthValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const toggleMarginUnit = (e) => {
    let marginUnit = e.target.value;

    let layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.element.id,
      (item) => {
        item.accordion.marginUnit = marginUnit;
      },
      (colItem) => {
        colItem.accordion.marginUnit = marginUnit;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const setAccordionMarginTop = (e, deviceType, action) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let marginUnit =
      e.target.value === "" ? 0 : e.target.value < 0 ? 0 : e.target.value;
    let desktopValue =
      action == "plus"
        ? Number(props.element.accordion.desktopStyle.marginTop) + 1
        : Number(props.element.accordion.desktopStyle.marginTop) - 1;
    let mobileValue =
      action == "plus"
        ? Number(props.element.accordion.mobileStyle.marginTop) + 1
        : Number(props.element.accordion.mobileStyle.marginTop) - 1;

    mobileValue < 0 ? (mobileValue = 0) : "";
    desktopValue < 0 ? (desktopValue = 0) : "";

    if (deviceType === "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.marginTop =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : marginUnit;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.marginTop =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : marginUnit;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType === "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.marginTop =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : marginUnit;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.marginTop =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : marginUnit;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setAccordionMarginBottom = (e, deviceType, action) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");

    let marginUnit =
      e.target.value === "" ? 0 : e.target.value < 0 ? 0 : e.target.value;

    let desktopValue =
      action == "plus"
        ? Number(props.element.accordion.desktopStyle.marginBottom) + 1
        : Number(props.element.accordion.desktopStyle.marginBottom) - 1;
    let mobileValue =
      action == "plus"
        ? Number(props.element.accordion.mobileStyle.marginBottom) + 1
        : Number(props.element.accordion.mobileStyle.marginBottom) - 1;
    desktopValue = desktopValue < 0 ? 0 : desktopValue;
    mobileValue = mobileValue < 0 ? 0 : mobileValue;

    if (deviceType === "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.marginBottom =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : marginUnit;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.marginBottom =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : marginUnit;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType === "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.marginBottom =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : marginUnit;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.marginBottom =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : marginUnit;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setBorderWidth = (e, deviceType, action) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let borderwidthUnit =
      e.target.value === "" ? 0 : e.target.value < 0 ? 0 : e.target.value;
    let desktopValue =
      action == "plus"
        ? Number(props.element.accordion.desktopStyle.borderWidth) + 1
        : Number(props.element.accordion.desktopStyle.borderWidth) - 1;
    let mobileValue =
      action == "plus"
        ? Number(props.element.accordion.mobileStyle.borderWidth) + 1
        : Number(props.element.accordion.mobileStyle.borderWidth) - 1;
     desktopValue =
       desktopValue < 0 ? 0 : desktopValue > 30 ? 30 : desktopValue;
     mobileValue = mobileValue < 0 ? 0 : mobileValue > 30 ? 30 : mobileValue;

    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.borderWidth =
            action == "plus"
              ? desktopValue
              : action == "minus"
              ? desktopValue
              : borderwidthUnit;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.borderWidth =
            action == "plus"
              ? desktopValue
              : action == "minus"
              ? desktopValue
              : borderwidthUnit;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.borderWidth =
            action == "plus"
              ? mobileValue
              : action == "minus"
              ? mobileValue
              : borderwidthUnit;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.borderWidth =
            action == "plus"
              ? mobileValue
              : action == "minus"
              ? mobileValue
              : borderwidthUnit;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const setAlignment = (e, deviceType, action) => {
    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.alignment = e.target.value;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.alignment = e.target.value;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.alignment = e.target.value;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.alignment = e.target.value;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const setBorderRadius = (e, deviceType, action) => {
    e.target.value = e.target.value && e.target.value.replace(/^0+/, "");
    let borderRadiusValue =
      e.target.value === "" ? 0 : e.target.value < 0 ? 0 : e.target.value;
    let desktopValue =
      action == "plus"
        ? Number(props.element.accordion.desktopStyle.borderRadius) + 1
        : Number(props.element.accordion.desktopStyle.borderRadius) - 1;
    let mobileValue =
      action == "plus"
        ? Number(props.element.accordion.mobileStyle.borderRadius) + 1
        : Number(props.element.accordion.mobileStyle.borderRadius) - 1;
  desktopValue = desktopValue < 0 ? 0 : desktopValue > 30 ? 30 : desktopValue;
  mobileValue = mobileValue < 0 ? 0 : mobileValue > 30 ? 30 : mobileValue;
    if (deviceType === "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.borderRadius =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : borderRadiusValue;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.borderRadius =
            action === "plus"
              ? desktopValue
              : action === "minus"
              ? desktopValue
              : borderRadiusValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType === "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.borderRadius =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : borderRadiusValue;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.borderRadius =
            action === "plus"
              ? mobileValue
              : action === "minus"
              ? mobileValue
              : borderRadiusValue;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const setBorderColor = (e, deviceType) => {
    const newColor = e.rgb;
    if (deviceType == "desktop") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.desktopStyle.borderColor = newColor;
        },
        (colItem) => {
          colItem.accordion.desktopStyle.borderColor = newColor;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
    if (deviceType == "mobile") {
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.element.id,
        (item) => {
          item.accordion.mobileStyle.borderColor = newColor;
        },
        (colItem) => {
          colItem.accordion.mobileStyle.borderColor = newColor;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  return (
    <Popup
      width="700"
      header="Accordion Settings"
      closePopup={props.closePopup}
      close={props.closePopup}
    >
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1");
            }}
          >
            General
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2");
            }}
          >
            Item Order
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <div className="modalScrollContainerSecondary">
            <div className="modalContentWrapper">
              <label htmlFor="row-label">
                Accordion Label <small>(For Meta Data and Aria Labels)</small>
              </label>
              <input
                onChange={addLabel}
                value={props.element.label}
                className="accordion-label-input"
                placeholder="Add Accordion Label"
                type="text"
              />
            </div>
            <div className="padding-section" style={{ marginBottom: "5px" }}>
              <div className="heading">Collapse / Expand</div>
            </div>

            <div className=" modalContentWrapper" style={{ columnGap: "5px" }}>
              <div className="heading-row">Desktop</div>
              <div className="icon-type-container">
                <label className="icon-type-select-label">
                  Multi Item Expand
                </label>

                <input
                  checked={props.element.accordion.desktopStyle.multiItemExpand}
                  onChange={multiItemExpandToggle}
                  value="desktop"
                  type="checkbox"
                ></input>
              </div>
              <div className="icon-type-container">
                <label className="icon-type-select-label">Icon Type</label>

                <select
                  value={props.element.accordion.desktopStyle.iconType}
                  onChange={selectIconType}
                  name="desktopIcon"
                >
                  {" "}
                  <option value="arrow">Arrow Up / Arrow Down</option>
                  <option value="solid">Solid / Hollow</option>
                  <option value="plus">Plus / Minus</option>
                </select>
              </div>

              <div className="heading-row">Mobile</div>
              <div className="icon-type-container">
                <label className="icon-type-select-label">
                  Multi Item Expand
                </label>

                <input
                  checked={props.element.accordion.mobileStyle.multiItemExpand}
                  onChange={multiItemExpandToggle}
                  value="mobile"
                  type="checkbox"
                ></input>
              </div>
              <div className="icon-type-container">
                <label className="icon-type-select-label">Icon Type</label>

                <select
                  value={props.element.accordion.mobileStyle.iconType}
                  onChange={selectIconType}
                  name="mobileIcon"
                >
                  <option value="solid">Solid / Hollow</option>
                  <option value="arrow">Arrow Up / Arrow Down</option>
                  <option value="plus">Plus / Minus</option>
                </select>
              </div>
            </div>

            <div className="padding-section" style={{ marginBottom: "5px" }}>
              <div className="heading">Width</div>
            </div>
            <div
              className="heading-row modalContentWrapper"
              style={{ justifyContent: "flex-end" }}
            >
              <UnitSelector
                defaultValue={props.element.accordion.widthUnit}
                onChange={toggleWidthUnit}
                value={props.element.accordion.widthUnit}
              />
            </div>
            <div
              className="d-flex modalContentWrapper"
              style={{ columnGap: "5px" }}
            >
              <div style={{ width: "50%" }}>
                <div className="heading-row">Desktop</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="options"
                >
                  <div className="d-block">
                    <Counter
                      label="Width"
                      small={
                        props.element.accordion.widthUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        let value =
                          (props.element.accordion.widthUnit === "%") &
                          (e.target.value > 100)
                            ? 100
                            : (props.element.accordion.widthUnit !== "%") &
                              (e.target.value > 1200)
                            ? 1200
                            : e.target.value;
                        setAccordionWidth(value, "desktop", "minus");
                      }}
                      valueContent={Number(
                        props.element.accordion.desktopStyle.width
                      )}
                      disabled={false}
                      onChange={(e) => {
                        let value =
                          (props.element.accordion.widthUnit === "%") &
                          (e.target.value > 100)
                            ? 100
                            : (props.element.accordion.widthUnit !== "%") &
                              (e.target.value > 1200)
                            ? 1200
                            : e.target.value;
                        setAccordionWidth(value, "desktop");
                      }}
                      plusClick={(e) => {
                        let value =
                          (props.element.accordion.widthUnit === "%") &
                          (e.target.value > 100)
                            ? 100
                            : (props.element.accordion.widthUnit !== "%") &
                              (e.target.value > 1200)
                            ? 1200
                            : e.target.value;
                        setAccordionWidth(value, "desktop", "plus");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className="heading-row">Mobile</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="options"
                >
                  <div className="d-block">
                    <Counter
                      label="Width"
                      small={
                        props.element.accordion.widthUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        let value =
                          (props.element.accordion.widthUnit === "%") &
                          (e.target.value > 100)
                            ? 100
                            : (props.element.accordion.widthUnit !== "%") &
                              (e.target.value > 375)
                            ? 375
                            : e.target.value;
                        setAccordionWidth(value, "mobile", "minus");
                      }}
                      valueContent={props.element.accordion.mobileStyle.width}
                      disabled={false}
                      onChange={(e) => {
                        let value =
                          (props.element.accordion.widthUnit === "%") &
                          (e.target.value > 100)
                            ? 100
                            : (props.element.accordion.widthUnit !== "%") &
                              (e.target.value > 375)
                            ? 375
                            : e.target.value;
                        setAccordionWidth(value, "mobile");
                      }}
                      plusClick={(e) => {
                        let value =
                          (props.element.accordion.widthUnit === "%") &
                          (e.target.value > 100)
                            ? 100
                            : (props.element.accordion.widthUnit !== "%") &
                              (e.target.value > 375)
                            ? 375
                            : e.target.value;
                        setAccordionWidth(value, "mobile", "plus");
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="padding-section" style={{ marginBottom: "5px" }}>
              <div className="heading">Alignment</div>
            </div>
            <div
              className="d-flex modalContentWrapper"
              style={{ columnGap: "5px" }}
            >
              <div style={{ width: "50%" }}>
                <div className="heading-row">Desktop</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="options"
                >
                  <div className="d-block">
                    <select
                      value={props.element.accordion.desktopStyle.alignment}
                      onChange={(e) => {
                        setAlignment(e, "desktop");
                      }}
                    >
                      <option>left</option> <option>center</option>
                      <option>right</option>
                    </select>
                  </div>
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className="heading-row">Mobile</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="options"
                >
                  <div className="d-block">
                    <select
                      defaultValue={"left"}
                      value={props.element.accordion.mobileStyle.alignment}
                      onChange={(e) => {
                        setAlignment(e, "mobile");
                      }}
                    >
                      <option>left</option>
                      <option>center</option>
                      <option>right</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="padding-section"
              style={{ marginTop: "15px", marginBottom: "5px" }}
            >
              <div className="heading">Margin</div>
            </div>

            <div
              className="heading-row modalContentWrapper"
              style={{ justifyContent: "flex-end" }}
            >
              <UnitSelector
                defaultValue={props.element.accordion.marginUnit}
                onChange={toggleMarginUnit}
              />
            </div>
            <div
              className="d-flex modalContentWrapper"
              style={{ columnGap: "5px" }}
            >
              <div style={{ width: "50%" }}>
                <div className="heading-row">Desktop</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="options"
                >
                  <div className="d-block">
                    <Counter
                      label="Top"
                      small={
                        props.element.accordion.marginUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setAccordionMarginTop(e, "desktop", "minus");
                      }}
                      valueContent={
                        props.element.accordion.desktopStyle.marginTop
                      }
                      disabled={false}
                      onChange={(e) => {
                        setAccordionMarginTop(e, "desktop");
                      }}
                      plusClick={(e) => {
                        setAccordionMarginTop(e, "desktop", "plus");
                      }}
                    />
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Bottom"
                      small={
                        props.element.accordion.marginUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setAccordionMarginBottom(e, "desktop", "minus");
                      }}
                      valueContent={
                        props.element.accordion.desktopStyle.marginBottom
                      }
                      disabled={false}
                      onChange={(e) => {
                        setAccordionMarginBottom(e, "desktop");
                      }}
                      plusClick={(e) => {
                        setAccordionMarginBottom(e, "desktop", "plus");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className="heading-row">Mobile</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="options"
                >
                  <div className="d-block">
                    <Counter
                      label="Top"
                      small={
                        props.element.accordion.marginUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setAccordionMarginTop(e, "mobile", "minus");
                      }}
                      valueContent={
                        props.element.accordion.mobileStyle.marginTop
                      }
                      disabled={false}
                      onChange={(e) => {
                        setAccordionMarginTop(e, "mobile");
                      }}
                      plusClick={(e) => {
                        setAccordionMarginTop(e, "mobile", "plus");
                      }}
                    />
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Bottom"
                      small={
                        props.element.accordion.marginUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setAccordionMarginBottom(e, "mobile", "minus");
                      }}
                      valueContent={
                        props.element.accordion.mobileStyle.marginBottom
                      }
                      disabled={false}
                      onChange={(e) => {
                        setAccordionMarginBottom(e, "mobile");
                      }}
                      plusClick={(e) => {
                        setAccordionMarginBottom(e, "mobile", "plus");
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className="padding-section"
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              <div className="heading">Border</div>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column" }}
              className="modalContentWrapper"
            >
              {" "}
              <div className="heading-row">Desktop</div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ display: "flex", marginRight: "20px" }}>
                  <Counter
                    label="Border Width"
                    minusClick={(e) => setBorderWidth(e, "desktop", "minus")}
                    value={props.element.accordion.desktopStyle.borderWidth}
                    valueContent={
                      props.element.accordion.desktopStyle.borderWidth
                    }
                    disabled={false}
                    onChange={(e) => {
                      setBorderWidth(e, "desktop");
                    }}
                    plusClick={(e) => setBorderWidth(e, "desktop", "plus")}
                  />
                </div>

                <Counter
                  label="Border Radius"
                  minusClick={(e) => {
                    setBorderRadius(e, "desktop", "minus");
                  }}
                  valueContent={
                    props.element.accordion.desktopStyle.borderRadius
                  }
                  disabled={false}
                  onChange={(e) => {
                    setBorderRadius(e, "desktop");
                  }}
                  plusClick={(e) => {
                    setBorderRadius(e, "desktop", "plus");
                  }}
                />

                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "20px",
                    width: "300px",
                  }}
                >
                  <ColorPicker
                    btnLabel="Border Color"
                    colorValue={
                      props.element.accordion.desktopStyle.borderColor
                    }
                    colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                    getColor={(e) => {
                      setBorderColor(e, "desktop");
                    }}
                  />
                </div>
              </div>
              <div className="heading-row">Mobile</div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ display: "flex", marginRight: "20px" }}>
                  <Counter
                    label="Border Width"
                    minusClick={(e) => setBorderWidth(e, "mobile", "minus")}
                    valueContent={
                      props.element.accordion.mobileStyle.borderWidth
                    }
                    disabled={false}
                    onChange={(e) => {
                      setBorderWidth(e, "mobile");
                    }}
                    plusClick={(e) => setBorderWidth(e, "mobile", "plus")}
                  />
                </div>
                <div>
                  <Counter
                    label="Border Radius"
                    minusClick={(e) => {
                      setBorderRadius(e, "mobile", "minus");
                    }}
                    valueContent={
                      props.element.accordion.mobileStyle.borderRadius
                    }
                    disabled={false}
                    onChange={(e) => {
                      setBorderRadius(e, "mobile");
                    }}
                    plusClick={(e) => {
                      setBorderRadius(e, "mobile", "plus");
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "20px",
                    width: "300px",
                  }}
                >
                  <ColorPicker
                    btnLabel="Border Color"
                    colorValue={props.element.accordion.mobileStyle.borderColor}
                    colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                    getColor={(e) => {
                      setBorderColor(e, "mobile");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane tabId="2">
          <div className="modalScrollContainerSecondary">
            <div className="modalContentWrapper">
              <SortableDragAndDrop
                element={props.element}
                initialItems={initialItems}
                actions={[
                  {
                    name: "Edit",
                    onClick: (itemIndex) => {
                      props.toggleAccordionItemSettings(itemIndex);
                    },
                    icon: EditIcon ,
                  },
                  {
                    name: "Delete",
                    onClick: (itemIndex) => {
                      props.removeSpecificColumn(itemIndex);
                    },
                    icon: DeleteIcon ,
                  },
                  {
                    name: "Duplicate",
                    onClick: (itemIndex) => {
                      props.duplicateColumn(itemIndex);
                    },
                    icon: DuplicateIcon ,
                  },
                ]}
              />
            </div>
          </div>
        </TabPane>
      </TabContent>
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccordionSettings);
